export default __webpack_public_path__ + "static/meta-89a7cf622780c8420e88a27c643e1f1f.png";